module.exports = __webpack_public_path__ + "static/img/page52.c609a0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page52.jpg
// module id = Ovz+
// module chunks = 0